import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Grid, Avatar } from '@mui/material';
import axios from '../axios';
import MedalIcon from '@mui/icons-material/MilitaryTech'; // Icona della medaglia

const Valutazioni = ({ idAlunno }) => {
    const [valutazioni, setValutazioni] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        const fetchValutazioni = async () => {
            try {
                const response = await axios.post('datahandler/corso-alunno-valutazioni', {
                    idAlunno: idAlunno,
                    token: token
                });
                setValutazioni(response.data);
            } catch (error) {
                console.error('Error fetching valutazioni:', error);
            }
        };

        fetchValutazioni();
    }, [idAlunno]);

    return (
        <Box mt={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#444', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 4, height: 18, bgcolor: '#ff9800', borderRadius: 4 }} />
                Valutazioni
            </Typography>
            <Grid container spacing={2}>
                {valutazioni.length > 0 ? (
                    valutazioni.map((valutazione, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card
                                className="glass-course-card"
                                sx={{
                                    background: 'rgba(255, 255, 255, 0.4)',
                                    backgroundImage: 'linear-gradient(135deg, rgba(255,183,77,0.1) 0%, rgba(255,255,255,0) 100%)',
                                }}
                            >
                                <CardContent sx={{ py: '12px !important' }}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <Avatar sx={{
                                                bgcolor: 'rgba(255, 183, 77, 0.2)',
                                                color: '#f57c00',
                                                border: '1px solid rgba(255, 183, 77, 0.3)',
                                                width: 44,
                                                height: 44
                                            }}>
                                                <MedalIcon fontSize="medium" />
                                            </Avatar>
                                        </Grid>
                                        <Grid item xs>
                                            <Typography variant="caption" sx={{ color: '#666', fontWeight: 600, display: 'block', mb: 0.2 }}>
                                                {`${valutazione.dat.substring(6, 8)}/${valutazione.dat.substring(4, 6)}/${valutazione.dat.substring(0, 4)}`}
                                            </Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 800, color: '#333', fontSize: '1rem' }}>
                                                {valutazione.val}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ color: '#999', fontStyle: 'italic', textAlign: 'center', py: 2 }}>
                            Nessuna valutazione registrata.
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default Valutazioni;
